import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  useMediaQuery,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import Logo from "../../assets/images/XymphonyLogo.png";
import notification from "../../assets/notification.svg";
import displayPicture from "../../assets/Rectangle 41106.svg";
import menu from "../../assets/align-justify.svg";
import searchIcon from "../../assets/search.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AgencyHeaderStyles } from "./AgencyHeaderStyles";
import SearchField from "../SearchField/SearchField";
import AddTaskIcon from "@mui/icons-material/AddTask";

import {
  DISPLAY_PICTURE,
  MENU,
  MENU_ICON,
  NOTIFICATION,
  SEARCH_ICON,
  SIMS_LOGO,
} from "../../constants";
import HeaderMenu from "../../Agents/HeaderMenu/HeaderMenu";
import Drawers from "../../Agents/Drawers/Drawers";
import AddTaskForm from "../../Agents/AddTaskForm/AddTaskForm";
import AgentFloaterButton from "../../Agents/AgentFloaterButton/AgentFloaterButton";

const AgencyHeader: React.FC = () => {
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleScroll = useCallback(() => {
    const currentScrollPos = window.pageYOffset;
    setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 10);
    setPrevScrollPos(currentScrollPos);
  }, [prevScrollPos]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos, visible, handleScroll]);

  const headerData = [
    {
      logo: Logo,
      notification: notification,
      displayPicture: displayPicture,
      menu: menu,
    },
  ];

  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    navigate("/agent/profileDetails");
  };

  const isMobile = useMediaQuery("(max-width:599px)");
  const isSmallScreen = useMediaQuery("(max-width:1023px)");

  const toggleMenu = () => {
    window.scrollTo({
      top: 0,
    });
    if (isMobile) {
      setIsMenuOpen(!isMenuOpen);
    } else {
      setIsDrawerOpen(true);
    }
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setIsFormOpen(false);
  };

  const handleIconClick = () => {
    setIsFormOpen(true);
  };

  const handleLogoClick = () => {
    const pathArray = location.pathname.split("/");
    if (pathArray?.length === 3 && pathArray[1] === "agent" && pathArray[2] === "mytasks"){
      window.location.reload()
    }else{
      navigate("/agent/mytasks")
    }

  }

  return (
    <>
      {(!isMenuOpen || !isMobile) && (
        <Box
          id="agency-header-container"
          data-test-id="test-agency-header-container"
          aria-label="Agency header container"
          sx={{
            ...AgencyHeaderStyles.headerContainer,
            // display: visible ? "flex" : "none",
            zIndex: 999,
            img: {
              height: "100%",
              zIndex: 999,
            },
          }}
        >
          <Box 
            id="agency-header-logo"
            data-test-id="test-agency-header-logo"
            aria-label="Agency logo container"
            sx={AgencyHeaderStyles.logo}
          >
            <img
              id="agency-header-sims-logo"
              data-test-id="test-agency-header-sims-logo"
              aria-label="SIMS logo"
              src={headerData[0].logo}
              style={AgencyHeaderStyles.simsLogo}
              alt={SIMS_LOGO}
              onClick={handleLogoClick}
            />
          </Box>
          {!isSmallScreen && <SearchField />}
          <Box 
            id="agency-header-items"
            data-test-id="test-agency-header-items"
            aria-label="Agency header items container"
            sx={AgencyHeaderStyles.headerItems}
          >
            <Box
              id="agency-header-floater-button"
              data-test-id="test-agency-header-floater-button"
              aria-label="Floater button container"
            >
              <AgentFloaterButton />
            </Box>
            <Box
              id="agency-header-notification"
              data-test-id="test-agency-header-notification"
              aria-label="Notification icon container"
            >
              {isSmallScreen ? (
                <img
                  id="agency-header-search-icon"
                  data-test-id="test-agency-header-search-icon"
                  aria-label="Search icon"
                  style={AgencyHeaderStyles.searchIcon}
                  src={searchIcon}
                  alt={SEARCH_ICON}
                />
              ) : (
                <img
                  id="agency-header-notification-icon"
                  data-test-id="test-agency-header-notification-icon"
                  aria-label="Notification icon"
                  src={headerData[0].notification}
                  alt={NOTIFICATION}
                  style={AgencyHeaderStyles.notificationIcon}
                />
              )}
            </Box>
            <Box 
              id="agency-header-profile"
              data-test-id="test-agency-header-profile"
              aria-label="Profile picture container"
              onClick={handleClick}
            >
              <img
                id="agency-header-display-picture"
                data-test-id="test-agency-header-display-picture"
                aria-label="Profile picture"
                src={headerData[0].displayPicture}
                alt={DISPLAY_PICTURE}
                style={AgencyHeaderStyles.displayPicture}
              />
            </Box>
            <Box 
              id="agency-header-menu"
              data-test-id="test-agency-header-menu"
              aria-label="Menu icon container"
              onClick={toggleMenu}
            >
              <img
                id="agency-header-menu-icon"
                data-test-id="test-agency-header-menu-icon"
                aria-label="Menu icon"
                src={headerData[0].menu}
                alt={MENU_ICON}
                style={AgencyHeaderStyles.menuIcon}
              />
            </Box>
          </Box>
        </Box>
      )}

      {isMenuOpen && isMobile && <HeaderMenu onClose={toggleMenu} />}

      {!isMobile && (
        <Drawers
          open={isDrawerOpen}
          toggleDrawer={closeDrawer}
          heading={MENU}
          additionalClass={AgencyHeaderStyles.drawer}
        >
          <HeaderMenu onClose={closeDrawer} />
        </Drawers>
      )}

      {isFormOpen && (
        <AddTaskForm open={isFormOpen} handleClose={closeDrawer} />
      )}
    </>
  );
};

export default AgencyHeader;
